/* Original name @uswitch/trustyle.social-sharing */
import React from 'react';
import { Themed } from 'theme-ui';
import { TruFacebook, TruTwitter, TruLinkedIn, TruEmail } from '@uswitch/spark-icons/tru';
import { Link } from '@uswitch/ev-core/react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var SocialSharing = function SocialSharing(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$labelText = _ref.labelText,
      labelText = _ref$labelText === void 0 ? 'Share this guide' : _ref$labelText,
      shareUrl = _ref.shareUrl,
      twitterMessage = _ref.twitterMessage,
      mailSubject = _ref.mailSubject;

  var styles = function styles(element) {
    return "compounds.social-sharing.".concat(element);
  };

  var encodedShareUrl = encodeURIComponent(shareUrl);
  return _jsxs(Themed.div, {
    className: className,
    sx: {
      variant: styles('main')
    },
    children: [labelText && _jsx(Themed.div, {
      sx: {
        variant: styles('label')
      },
      children: labelText
    }) || '', _jsxs(Themed.div, {
      sx: {
        variant: styles('buttons')
      },
      children: [_jsx(Link, {
        href: "https://www.facebook.com/sharer/sharer.php?u=".concat(encodedShareUrl),
        target: "_blank",
        sx: {
          textDecoration: 'none',
          cursor: 'pointer',
          borderBottom: 0,
          variant: styles('fb')
        },
        children: _jsx(TruFacebook, {
          size: 20,
          color: "#1877f2"
        })
      }), _jsx(Link, {
        href: "https://twitter.com/intent/tweet?".concat(twitterMessage ? "text=".concat(encodeURIComponent(twitterMessage)) : "url=".concat(encodedShareUrl)),
        target: "_blank",
        sx: {
          textDecoration: 'none',
          cursor: 'pointer',
          borderBottom: 0,
          variant: styles('tw')
        },
        children: _jsx(TruTwitter, {
          size: 20,
          color: "#1d9bf0"
        })
      }), _jsx(Link, {
        href: "https://www.linkedin.com/sharing/share-offsite/?url=".concat(encodedShareUrl),
        target: "_blank",
        sx: {
          textDecoration: 'none',
          cursor: 'pointer',
          borderBottom: 0,
          variant: styles('ln')
        },
        children: _jsx(TruLinkedIn, {
          size: 24,
          color: "#2867b2"
        })
      }), _jsx(Link, {
        href: "mailto:?subject=".concat(encodeURIComponent(mailSubject), "&body=").concat(encodedShareUrl),
        sx: {
          textDecoration: 'none',
          cursor: 'pointer',
          borderBottom: 0,
          variant: styles('email')
        },
        children: _jsx(TruEmail, {
          size: 16,
          color: "primary"
        })
      })]
    })]
  });
};

export default SocialSharing;
//# sourceMappingURL=index.js.map